import { render } from "./research.vue?vue&type=template&id=69bd3836&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"

import "./research.vue?vue&type=style&index=0&id=69bd3836&scoped=true&lang=scss"

import exportComponent from "/home/duke/code/duke-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69bd3836"]])

export default __exports__